function init () {
  $(function () {
    $("#zy_menu_left").on('click', '.icon_c', function () {
      if ($(this).hasClass('up_icon')) {
        $(this).parent('dt').next().css('display', 'block')
        $(this).removeClass('up_icon').addClass('down_icon');
      } else if ($(this).hasClass('down_icon')) {
        $(this).parent('dt').next().css('display', 'none')
        $(this).removeClass('down_icon').addClass('up_icon');
      }
    })
  })
  $(function () {
      $(".total-scope-train").each(function () {
        $(this).mouseover(function () {
          $(this).find('.total-scope-tan').show();
        })
      })
      $(".total-scope-train").each(function () {
        $(this).mouseleave(function () {
          $(this).find('.total-scope-tan').hide();
        })
      })
    }
  );

  $(function () {
    /* 登录切换 */
    loadTab();
  });

  function resetTabs (obj) {
    $(obj).parent().parent().next("div").find("div").hide();
    $(obj).parent().parent().find("a").removeClass("current");
  }

  function loadTab () {
    $(".tab_content > div").hide();
    $(".tabs").each(function () {
      $(this).find("li:first a").addClass("current");
    });
    $(".tab_content").each(function () {
      $(this).find("div:first").fadeIn();
    });
    $(".tabs a").on("click", function (e) {
      e.preventDefault();
      if ($(this).attr("class") == "current") {

      } else {
        resetTabs(this);
        $(this).addClass("current");
        $($(this).attr("name")).fadeIn();
      }
    });
  }
}

export {
  init
}



// WEBPACK FOOTER //
// ./src/assets/js/public.js